export default [
  {
    path: '/profile_qualifications',
    meta: { auth: 'administrator' },
    component: () => import(/* webpackChunkName: 'profile-qualifications-list' */ '@/views/profile_qualifications/List.vue')
  }
]
